import React from 'react';

type Props = {
  width?: number;
  height?: number;
};

const IconFile: React.FC<Props> = ({ width = 24, height = 24 }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.40002 0.75H14.3893L20.8502 7.20996V20C20.8502 21.7949 19.3951 23.2499 17.6002 23.25H6.40002C4.6051 23.25 3.15002 21.7949 3.15002 20V4C3.15002 2.20508 4.6051 0.75 6.40002 0.75Z"
      fill="white"
      stroke="#D5D7DA"
      stroke-width="1.5"
    />
    <path
      d="M14.4 0.300003V3.2C14.4 5.40914 16.1909 7.2 18.4 7.2H21.3"
      stroke="#D5D7DA"
      stroke-width="1.5"
    />
  </svg>
);

export default IconFile;
